@if (vm$ | async; as vm) {
	<div class="grid grid-cols-4 gap-2 lg:gap-4">
		@for (item of OB.item_desc; track item; let i = $index) {
			@let row = vm.rows[i];
			@if (row?.ob) {
				<div class="relative">
					<div
						class="ob-box h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
						[class.activeGrid]="row.ob.currentCount > 0"
						[class.added]="row.ob.lastAction === OB_LAST_ACTION.ADDED"
						[class.removed]="row.ob.lastAction === OB_LAST_ACTION.REMOVED"
						[class.disabledByGrey]="row.ob.lastAction === 'DISABLED'"
						[class.is-greyed]="isGreyed(i)"
						(pointerdown)="enableNA ? onCardPointerDown($event, i, row) : ''"
						(pointerup)="enableNA ? onCardPointerUp($event, i) : ''"
						(pointerleave)="enableNA ? onCardPointerCancel($event, i) : ''"
						(pointercancel)="enableNA ? onCardPointerCancel($event, i) : ''"
						(contextmenu)="enableNA ? onCardContextMenu($event, i, row) : ''"
					>
						<div class="mb-2 flex flex-row justify-between">
							<div class="gap flex flex-row items-center gap-1 lg:gap-2">
								<span class="grid-title text-sm font-bold lg:text-lg">
									{{ row.title }}
								</span>
								@if (!singleCount) {
									@if (row.ob.currentCount > 0 || row.ob.totalCount > 0) {
										<span class="ob-attempt text-[9px] lg:text-xs">
											[{{ row.ob.currentCount }}/{{ row.ob.totalCount }}]
										</span>
									}
								}
							</div>
							@if (showButtons) {
								@if (singleCount) {
									<div class="gap flex flex-row gap-1 lg:gap-4">
										@if (row.ob.currentCount > 0 || row.ob.totalCount > row.ob.currentCount || row.ob.preDefined) {
											<!-- Remove -->
											<button
												type="button"
												class="attemptBtn removeBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
												[disabled]="row.disabledRemove || isGreyed(i)"
												[class.opacity-50]="row.disabledRemove || isGreyed(i)"
												(click)="remove(i)"
												(pointerdown)="$event.stopPropagation()"
												(contextmenu)="$event.stopPropagation()"
											>
												-
											</button>
										}
										@if (row.ob.currentCount < 1) {
											<!-- Add -->
											<button
												type="button"
												class="attemptBtn addBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
												[disabled]="row.disabledAdd || isGreyed(i)"
												[class.opacity-50]="row.disabledAdd || isGreyed(i)"
												(click)="add(i)"
												(pointerdown)="$event.stopPropagation()"
												(contextmenu)="$event.stopPropagation()"
											>
												+
											</button>
										}
									</div>
								} @else {
									<div class="gap flex flex-row gap-1 lg:gap-4">
										<!-- Remove -->
										<button
											type="button"
											class="attemptBtn removeBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
											[disabled]="row.disabledRemove || isGreyed(i)"
											[class.opacity-50]="row.disabledRemove || isGreyed(i)"
											(click)="remove(i)"
											(pointerdown)="$event.stopPropagation()"
											(contextmenu)="$event.stopPropagation()"
										>
											-
										</button>
										<!-- Add -->
										<button
											type="button"
											class="attemptBtn addBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
											[disabled]="row.disabledAdd || isGreyed(i)"
											[class.opacity-50]="row.disabledAdd || isGreyed(i)"
											(click)="add(i)"
											(pointerdown)="$event.stopPropagation()"
											(contextmenu)="$event.stopPropagation()"
										>
											+
										</button>
									</div>
								}
							}
						</div>
						<p class="grid-description text-black">{{ item }}</p>
					</div>
					@if (row.ob.preDefined) {
						<div class="absolute bottom-[10px] right-[10px]">
							<img src="/assets/predefined_stars.png" alt="predefined" />
						</div>
					}
				</div>
			}
		}
	</div>
}
